import React from 'react';
import {useBodyColor} from "../hooks";
import {useHistory} from "react-router";
import MobilePage from "../components/MobilePage";
import {Card, Elevation, Button} from "@blueprintjs/core";
import {DropDownTeamSelector} from "../report-score-team-select/drop-down-team-selector/apollo";
import {TeamByIdSelector} from "../report-score-team-select/team-by-id-selector";
import styled from "styled-components";

const Wrapper = styled.div`
  padding: 12px;
  width: 100%;
`

export default ({ setTeamId }) => {
  useBodyColor('#ECF7FE')

  const [dropDownTeamSelectChoice, setDropDownTeamSelectChoice] = React.useState(null);
  const [teamIdSelectorChoice, setTeamIdSelectorChoice] = React.useState(null);

  const history = useHistory()

  const canSubmit = React.useMemo(() => (dropDownTeamSelectChoice || teamIdSelectorChoice), [dropDownTeamSelectChoice, teamIdSelectorChoice])

  return (
    <MobilePage
      titleContent={
        <h1 style={{textAlign: 'center', margin: 0, padding: 0}}>Team Schedules & Game Results</h1>
      }
    >
      <Wrapper>
        <Card
          elevation={Elevation.ONE}
        >
          <DropDownTeamSelector
            disabled={teamIdSelectorChoice}
            onChange={setDropDownTeamSelectChoice}
          />
        </Card>

        {/*
        <h2 style={{textAlign: 'center'}}>OR</h2>

        <Card
          elevation={Elevation.ONE}
        >
          <TeamByIdSelector
            disabled={dropDownTeamSelectChoice}
            onTeamIdChange={setTeamIdSelectorChoice}
          />
        </Card>
        */}

        <div
          style={{
            marginTop: '50px',
            display: 'flex',
            justifyContent: 'center'
          }}
        >
          <Button
            disabled={!canSubmit}
            intent={'primary'}
            style={{width: '250px'}}
            onClick={() => {
              setTeamId(dropDownTeamSelectChoice ? dropDownTeamSelectChoice.id : teamIdSelectorChoice)
              history.push({pathname: '/home', search: `?teamId=${dropDownTeamSelectChoice ? dropDownTeamSelectChoice.id : teamIdSelectorChoice}`})
            }}
          >
            Go
          </Button>
        </div>
      </Wrapper>
    </MobilePage>
  )
}
